(function (root) {
  'use strict';

  // Dispatch calendar: England and Wales dates verified on 28 October 2026.
  // Source: https://www.gov.uk/bank-holidays
  // Refresh before 2029. No dated estimate is shown outside the verified range.
  var calendarStart = '2026-01-01';
  var calendarEnd = '2028-12-31';
  var bankHolidays = new Set([
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04',
    '2026-05-25', '2026-08-31', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03',
    '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28',
    '2028-01-03', '2028-04-14', '2028-04-17', '2028-05-01',
    '2028-05-29', '2028-08-28', '2028-12-25', '2028-12-26'
  ]);
  var londonClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  var calendarLabel = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
  });
  var pounds = new Intl.NumberFormat('en-GB', {
    style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2
  });
  var qualifier = 'UK working days only';

  function shortDate(date) {
    var fields = {};
    calendarLabel.formatToParts(date).forEach(function (part) { fields[part.type] = part.value; });
    return fields.weekday + ' ' + fields.day + ' ' + fields.month;
  }

  function dateKey(date) {
    return date.toISOString().slice(0, 10);
  }

  function supported(date) {
    var key = dateKey(date);
    return key >= calendarStart && key <= calendarEnd;
  }

  function workingDay(date) {
    var weekday = date.getUTCDay();
    return weekday !== 0 && weekday !== 6 && !bankHolidays.has(dateKey(date));
  }

  function nextWorkingDay(date) {
    var candidate = new Date(date.getTime());
    do {
      candidate.setUTCDate(candidate.getUTCDate() + 1);
      if (!supported(candidate)) return null;
    } while (!workingDay(candidate));
    return candidate;
  }

  function fallback() {
    return {
      headline: 'Order by 2pm for next working day delivery',
      detail: qualifier,
      estimate: ''
    };
  }

  /** Return plain text for an in-stock item's UK dispatch and estimated delivery. */
  function delivery(now) {
    var instant = now === undefined ? new Date() : new Date(now);
    if (!Number.isFinite(instant.getTime())) return fallback();
    var fields = {};
    londonClock.formatToParts(instant).forEach(function (part) { fields[part.type] = part.value; });
    // Arithmetic uses a UTC calendar date, independent of the customer's time zone and DST.
    var today = new Date(Date.UTC(Number(fields.year), Number(fields.month) - 1, Number(fields.day), 12));
    if (!supported(today)) return fallback();
    var remaining = 14 * 3600 - (Number(fields.hour) * 3600 + Number(fields.minute) * 60 + Number(fields.second));
    var dispatch = workingDay(today) && remaining > 0 ? today : nextWorkingDay(today);
    var arrival = dispatch && nextWorkingDay(dispatch);
    if (!dispatch || !arrival) return fallback();

    var headline;
    if (today.getUTCDay() === 0 || today.getUTCDay() === 6) {
      headline = 'Dispatches ' + shortDate(dispatch);
    } else if (bankHolidays.has(dateKey(today))) {
      headline = 'Dispatches ' + shortDate(dispatch);
    } else if (remaining <= 0) {
      headline = '2pm cut-off passed — dispatches ' + shortDate(dispatch);
    } else {
      headline = 'Order within ' + Math.floor(remaining / 3600) + 'h ' +
        Math.floor((remaining % 3600) / 60) + 'm ' + (remaining % 60) +
        's for next working day delivery';
    }
    return {
      headline: headline,
      detail: '',
      estimate: 'Estimated delivery: ' + shortDate(arrival)
    };
  }

  /** Approximate per-set price rounded to the nearest penny; input is pack price in pence. */
  function unitPrice(priceCents, packCount) {
    if (!Number.isSafeInteger(priceCents) || priceCents < 0 ||
        !Number.isSafeInteger(packCount) || packCount <= 0) return '';
    return pounds.format(Math.round(priceCents / packCount) / 100);
  }

  var api = Object.freeze({ delivery: delivery, unitPrice: unitPrice });
  if (root) root.CBNaturalPurchaseUtils = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : null);
